import Units from "../../../utils/Units";
import StaticAxis from "../axes/StaticAxis";
import Day from "../axes/Day";
import Config from "../../../Config";
import Time from "../axes/Time";

let MilkLightRed = {
    type: "line",
    label: "Milk Warn Light",
    fill: false,
    lineTension: 0,
    colorPalette: 13,
    borderWidth:0,
    showLine:false,
    spanGaps: false,

    pointStyle: "rectRot",
    pointRadius:6,
    pointHoverRadius:7,
    pointBorderWidth:1,
    pointBackgroundColor: Config.colorPalette[6]['stroke'],

    /** show allways at 80% position*/
    dataTransformCallback: function(time, channelValue, dataSets) {
        if (null !== channelValue) {
            return 5;
        }

        return null;
    },

    /**show real string value*/
    tooltipLabelValueCallback: (value, point) => {
        return point['v'];
    },

    yAxis:StaticAxis,
    xAxis:Time
};

export default MilkLightRed;



// WEBPACK FOOTER //
// ./src/components/chart/channels/MilkLightRed.js